<template lang="pug">
el-dialog(
  :title="!ruleForm.id ? '新建比赛' : '修改比赛信息'",
  class="el-dialog-custom",
  top="3vh",
  width="95%",
  :visible.sync="visible",
  :append-to-body="true",
  :modal-append-to-body="false",
  @close="closeForm()"
)
  el-form(
    :model="ruleForm",
    :inline="false",
    :rules="rules",
    ref="ruleForm",
    label-width="140px",
    @submit.native.prevent
  )
    el-card(shadow="never")
      div(slot="header")
        font(style="font-weight: bold; font-size: 18px") 比赛设置
      div
        el-form-item(label="比赛ID:", prop="matchId", v-show="false")
          el-input.width_ct(v-model="ruleForm.matchId", disabled)
          font.font_later(v-if="!ruleForm.matchId") 新建后自动生成!
        el-form-item(label="比赛名称:", prop="matchName")
          el-input.width_ct(
            v-model="ruleForm.matchName",
            @input="descInput",
            placeholder="请填写比赛名称",
            type="text",
            maxlength="40",
            show-word-limit
          )
          font.font_later 您还可以输入
          font.font_style {{ nameFont }}
          font.font_color 个字!
        el-form-item(label="主办方:", prop="userGroupId")
          el-select.sel_width_ct(
            v-model="ruleForm.userGroupId",
            placeholder="请选择主办方",
            filterable,
            clearable,
            @change="changeCity"
          )
            el-option(
              v-for="(item, index) in sysOrgList",
              :key="index",
              :label="item.name",
              :value="item.orgId"
            )
        el-form-item(label="主办城市:", prop="city")
          el-col(style="width: 20%")
            el-select(
              v-model="ruleForm.provinceCode",
              placeholder="请选择省",
              style="width: 100%",
              :disabled="cityDisbaled",
              @change="changeProvice"
            )
              el-option(
                v-for="(item, index) in provinceList",
                :key="index",
                :label="item.name",
                :value="item.code"
              )
          el-col.line(style="width: 2%") &nbsp;&nbsp;省&nbsp;&nbsp;
          el-col(style="width: 20%")
            el-select(
              v-model="ruleForm.cityCode",
              placeholder="请选择市",
              style="width: 100%",
              :disabled="provinceDisabled",
              @change="selectCity"
            )
              el-option(
                v-for="(item, index) in cityList",
                :key="index",
                :label="item.cityname",
                :value="item.citycode"
              )
          el-col(style="width: 20%") &nbsp;&nbsp;市&nbsp;
        el-form-item(label="比赛场地:", prop="venueId")
          el-select.sel_width_ct(
            v-model="ruleForm.venueId",
            placeholder="请选择比赛场地",
            clearable,
            :disabled="venueIdDisabled",
            @change="venueIdChange"
          )
            el-option(
              v-for="(item, index) in venueList",
              :key="index",
              :label="item.name",
              :value="item.id"
            )
          font.font_later(v-if="ruleForm.venueAddress") 地址: {{ ruleForm.venueAddress }}
        el-form-item(label="比赛类型:", prop="ctType")
          el-select.sel_width_ct(
            v-model="ruleForm.ctType",
            @change="changectType",
            placeholder="请选择比赛类型",
            clearable
          )
            el-option(label="挑战赛", :value="5")
            el-option(label="群英赛", :value="6")
        el-form-item(label="胜负判定方式:", prop="outcomeType")
          el-radio(v-model="ruleForm.outcomeType", :label="0") 胜场制
          el-radio(v-model="ruleForm.outcomeType", :label="1") 积分制
        el-form-item(label="积分配置:", prop="ifDoublePoint")
          el-radio(v-model="ruleForm.ifDoublePoint", :label="0") 单倍积分
          el-radio(v-model="ruleForm.ifDoublePoint", :label="1") 双倍积分
        el-form-item(label="签位:", prop="applySize")
          el-col(style="width: 15%")
            el-input(
              v-model="ruleForm.applySize",
              @change="changeappsize",
              clearable,
              :disabled="isReviewedEdit && ruleForm.inGameManagementMode != 0",
              placeholder="请填写签位数"
            )
        el-form-item(label="报名时间:", prop="applyDate")
          el-date-picker(
            v-model="ruleForm.applyDate",
            @blur="applyDateChange",
            range-separator="至",
            type="datetimerange",
            start-placeholder="开始时间",
            end-placeholder="截止时间",
            :picker-options="pickerOptions",
            format="yyyy-MM-dd HH:mm",
            value-format="yyyy-MM-dd HH:mm",
            :clearable="false"
          )
        el-form-item(label="调整报名名单时间:", prop="RegistrationList")
          el-date-picker(
            v-model="ruleForm.RegistrationList",
            @blur="applyDateChange1",
            :disabled="ruleForm.applyDate.length === 0",
            :picker-options="pickerOptionsCt",
            range-separator="至",
            type="datetimerange",
            start-placeholder="开始时间",
            end-placeholder="截止时间",
            format="yyyy-MM-dd HH:mm",
            value-format="yyyy-MM-dd HH:mm",
            :clearable="false",
            @change="changeSignUpStartTime"
          )

        el-form-item(
          label="调整出场名单时间:",
          prop="AttendanceList",
          v-show="ruleForm.inGameManagementMode==1"
        )
          el-date-picker(
            v-model="ruleForm.AttendanceList",
            @blur="applyDateChange2",
            :disabled="ruleForm.RegistrationList.length === 0",
            :picker-options="pickerOptionsCt1",
            range-separator="至",
            type="datetimerange",
            start-placeholder="开始时间",
            end-placeholder="截止时间",
            format="yyyy-MM-dd HH:mm",
            value-format="yyyy-MM-dd HH:mm",
            :clearable="false"
          )
        el-form-item(label="比赛时间:", prop="matchStartTime")
          el-date-picker(
            v-model="ruleForm.matchStartTime",
            type="datetime",
            :disabled="ruleForm.inGameManagementMode == 1 && ruleForm.AttendanceList.length === 0",
            :placeholder="matchStartTimePlaceholder",
            format="yyyy-MM-dd HH:mm",
            @change="changeMatchStartTime",
            :picker-options="pickerOptionsCt2",
            value-format="yyyy-MM-dd HH:mm",
            :clearable="false"
          )
        //- 添加无赛中模式
        el-form-item(label="赛中管理模式:", prop="inGameManagementMode")
          el-radio(v-model="ruleForm.inGameManagementMode", :label="1", :disabled="isInGameManagementMode") 赛中管理
          el-radio(v-model="ruleForm.inGameManagementMode", :label="0") 无赛中管理
        div(style="margin-bottom: 22px; height: 40px; display: flex; align-items: center; color: #606266;")
          div(style="padding-right: 12px; width: 128px; text-align: right;") 场地数量:
          div(style="color: #303133;") {{ ruleForm.__placeInfoTemp__.length }}
        el-form-item(
          v-if="ruleForm.inGameManagementMode == 1"
          label="场地信息:"
          style="margin-bottom: 0;"
          required
        )
          el-form-item(
            v-for="(item, index) in ruleForm.__placeInfoTemp__",
            :prop="`__placeInfoTemp__[${index}].name`"
            :rules="[{ required: true, message: '请填写场地信息!', trigger: 'blur' }]"
            style="display: inline-block; margin-right: 10px; margin-bottom: 22px; width: 238px;"
          )
            el-input(
              v-model="item.name",
              clearable,
              placeholder="请填写场地信息"
            )
          i(
            class="el-icon-circle-plus-outline"
            style="margin-right: 5px; font-size: 28px; cursor: pointer; transform: translateY(6px);"
            @click="addPlaceInfoTemp"
          )
          i(
            v-if="ruleForm.__placeInfoTemp__.length > 1"
            class="el-icon-remove-outline"
            style="font-size: 28px; cursor: pointer; transform: translateY(6px);"
            @click="deletePlaceInfoTemp"
          )

        el-form-item(label="积分起始点:", prop="startScore")
          el-input.sel_width_ct(
            v-model="ruleForm.startScore",
            clearable,
            placeholder="请填写积分起始点"
          )
          span(style="font-size: 14px; margin-left: 10px; color: rgb(98 98 98)") 积分（默认1积分，可修改）
          span(style="font-size: 14px; margin-left: 20px;") 冠军加分：
          el-input-number.sel_width_ct_small(
            v-model="ruleForm.championAddPoints",
            clearable,
            size="small",
            :min="-99"
          )
          span(style="font-size: 14px; margin-left: 10px; color: rgb(98 98 98)")
        el-form-item(label="个人参与积分:", prop="personPointsRules")
          el-select.sel_width_ct(
            v-model="ruleForm.personPointsRules",
            placeholder="请选择个人是否参与积分",
            clearable
          )
            el-option(
              v-for="(item, index) in pointsRulesList",
              :key="index",
              :label="item.label",
              :value="item.key"
            )
          span(style="font-size: 14px; font-weight: 600; margin-left: 10px; color: rgb(98 98 98)") 计算规则
          span(style="font-size: 14px; margin-left: 20px;") 胜利：
          el-input-number.sel_width_ct_small(
            v-model="ruleForm.personWinPoints",
            clearable,
            :disabled="disabledPersonPointsRules"
            size="small"
          )
          span(style="font-size: 14px; margin-left: 20px;") 失败：
          el-input-number.sel_width_ct_small(
            v-model="ruleForm.personFailPoints",
            clearable,
            :disabled="disabledPersonPointsRules"
            size="small"
          )
          span(style="font-size: 14px; margin-left: 20px;") 弃权：
          el-input-number.sel_width_ct_small(
            v-model="ruleForm.personAbandonPoints",
            clearable,
            :disabled="disabledPersonPointsRules"
            size="small"
          )
        el-form-item(label="俱乐部参与积分:", prop="clubPointsRules")
          el-select.sel_width_ct(
            v-model="ruleForm.clubPointsRules",
            placeholder="请选择俱乐部是否参与积分",
            clearable
          )
            el-option(
              v-for="(item, index) in pointsRulesList",
              :key="index",
              :label="item.label",
              :value="item.key"
            )
          span(style="font-size: 14px; font-weight: 600; margin-left: 10px; color: rgb(98 98 98)") 计算规则
          span(style="font-size: 14px; margin-left: 20px;") 胜利：
          el-input-number.sel_width_ct_small(
            v-model="ruleForm.clubWinPoints",
            clearable,
            :disabled="disabledClubPointsRules"
            size="small"
          )
          span(style="font-size: 14px; margin-left: 20px;") 失败：
          el-input-number.sel_width_ct_small(
            v-model="ruleForm.clubFailPoints",
            clearable,
            :disabled="disabledClubPointsRules"
            size="small"
          )
          span(style="font-size: 14px; margin-left: 20px;") 弃权：
          el-input-number.sel_width_ct_small(
            v-model="ruleForm.clubAbandonPoints",
            clearable,
            :disabled="disabledClubPointsRules"
            size="small"
          )
        el-form-item(label="是否第六人:")
          el-radio(v-model="ruleForm.competitionClub.sixthMan", :label="1") 是
          el-radio(v-model="ruleForm.competitionClub.sixthMan", :label="0") 否

        el-form-item(label="联系电话:", prop="contactMobile")
          el-input.sel_width_ct(
            v-model="ruleForm.contactMobile",
            placeholder="请填写联系电话",
            type="text",
            maxlength="11"
            clearable
          )

        el-form-item(label="列表页图:", prop="imgList")
          el-input(v-model="ruleForm.imgList", v-show="false")
          //- el-upload(:http-request="uploadFileList",action="useless" :before-upload="beforeAvatarUpload" :show-file-list="false" class="avatar-uploader")
          img.avatar(
            v-if="listImageUrl",
            :src="listImageUrl",
            style="width: 256px; height: 190px",
            @click="openImgdailog(1)"
          )
          i.el-icon-plus.avatar-uploader-icon(
            v-else,
            style="width: 240px; height: 174px",
            @click="openImgdailog(1)"
          )
          imgupload(
            v-if="openImg",
            ref="upimg",
            :width="256",
            :height="190",
            @uploadSuccess="doneup_lb"
          )
          el-alert(
            title="建议最小分辨率256×190,上传图片格式仅支持jpg,jpeg,png,大小不超过10M",
            effect="light",
            :closable="false",
            style="margin-top: 10px"
          )
        el-form-item(label="详情页图:", prop="imgDetailList")
          el-input(v-model="ruleForm.imgDetailList", v-show="false")
          //- el-upload(:http-request="uploadFileDetail",action="useless" :before-upload="beforeAvatarUpload" :show-file-list="false" class="avatar-uploader")
          img.avatar(
            v-if="detailImageUrl",
            :src="detailImageUrl",
            style="width: 750px; height: 310px",
            @click="openImgdailog(2)"
          )
          i.el-icon-plus.avatar-uploader-icon(
            v-else,
            style="width: 317px; height: 178px",
            @click="openImgdailog(2)"
          )
          imgupload(
            v-if="openImg",
            ref="upimg2",
            :width="750",
            :height="310",
            @uploadSuccess="doneup_xq"
          )
          el-alert(
            title="建议最小分辨率750×310,上传图片格式仅支持jpg,jpeg,png,大小不超过10M",
            effect="light",
            :closable="false",
            style="margin-top: 10px"
          )
        el-form-item(label="比赛简介:", prop="matchDescription")
          el-input(
            v-model="ruleForm.matchDescription",
            type="textarea",
            style="display: none"
          )
          d2-quill(
            v-show="showQuill"
            ref="d2-quill",
            v-model="ruleForm.matchDescription",
            style="min-height: 200px"
          )
        el-form-item(label="报名须知:", prop="gameDescription")
          d2-quill(
            v-show="showQuill"
            ref="gameDescription",
            v-model="ruleForm.gameDescription",
            style="min-height: 200px"
          )
        el-form-item(label="比赛规程:", prop="imgDetailList")
          <div v-for="(item,index) in pdfs" style="display:flex">
            <div style="width:600px"> {{item.fileName}}</div>
            <div v-if="item.loading"> ({{item.loading}}%)</div>
            <a v-if="item.loading == 100" :href="item.url" target="_blank" style="text-decoration: none;margin-left:50px"> 下载</a>
            <div v-if="item.loading == 100" @click="deletePdf(index)" style="margin-left:50px"> 删除</div>
          </div>
          el-upload.upload-demo(
            drag,
            action=process.env.VUE_APP_API + "/admin/upload/uploadFile",
            :on-error="loadingFail",
            :before-upload="handleLoading",
            :on-success="savePdfUrl",
            :show-file-list="false",
            :data="uploadData",
            :headers="uploadHeader",
            style="max-width: 500px"
          )
            i.el-icon-upload
            .el-upload__text 将文件拖到此处，或
              em 点击上传
          el-alert(
            title="上传格式仅支持是.pdf，.doc或.docx,大小不超过10M",
            effect="light",
            :closable="false",
            style="margin-top: 10px"
          )
    br
    el-card(shadow="never")
      div(slot="header")
        font(style="font-weight: bold; font-size: 18px") 报名限定

      div
        el-form-item(label="报名限定：" prop="presidentLimit")
          el-radio(v-model="ruleForm.presidentLimit" :label="0") 限会长
          el-radio(v-model="ruleForm.presidentLimit" :label="1") 不限

        el-form-item(label="队伍人数：")
          el-input-number(
            v-model="ruleForm.teamMin"
            :disabled="true"
            :min=0
            :max="teamMaxSelect"
            @change="teamMaxChange"
          )
          span &nbsp;&nbsp;---&nbsp;&nbsp;
          el-input-number(
            v-model="ruleForm.teamMax"
            :min="6"
            :max=100
            @change="teamMinChange"
          )
          span &nbsp;&nbsp;人

        el-form-item(label="俱乐部等级：" prop="presidentLimit")
          el-checkbox-group(v-model="checkedCities" @change="handleCheckedCitiesChange")
            el-checkbox(v-for="(city, index) in cities" :label="city.label" :disabled="isReviewedEdit || city.disabed" :key="index") {{ city.value }}

        div(v-if="competitionRulesTab" style="margin-bottom: 20px; display: flex; color: #606266;")
          div(style="margin-right: 12px; width: 128px; text-align: right;") 赛制配置：
          div(style="padding: 20px; flex: 1; border: 1px solid #CDCDCD;")
            el-tabs(v-model="competitionRulesTab")
              el-tab-pane(v-for="(item, index) in cities" :keys="index" :label="item.value" :name="item.label" :disabled="item.disabed || !checkedCities.includes(item.label)")
                div
                  div(style="display: flex;")
                    div(style="margin-right: 20px; display: flex; align-items: center;")
                      div
                        span(style="margin-right: 37px; color: red;")
                        span 级别别名：
                      div
                        el-input(
                          v-model="competitionRules[index].groupNickname"
                          :disabled="isReviewedEdit"
                          style="width: 200px;"
                          placeholder="请填写级别别名"
                          maxlength="50"
                          clearable
                        )
                    div(style="display: flex; align-items: center;")
                      div
                        span(style="color: red;") *&nbsp;
                        span 级别队伍数：
                      div
                        el-input(
                          v-model="competitionRules[index].teamNum"
                          :disabled="isReviewedEdit"
                          style="width: 200px;"
                          placeholder="请填写级别队伍数"
                          maxlength="3"
                          clearable
                          @change="changeappsize(index)"
                        )
                  div(v-if="ruleForm.inGameManagementMode == 1" style="margin-top: 10px; display: flex;")
                    div(style="margin-right: 20px; display: flex; align-items: center;")
                      div
                        span(style="color: red;") *&nbsp;
                        span 第一阶段赛制：
                      div
                        el-select(
                          v-model="competitionRules[index].FirstCompetition"
                          :disabled="isReviewedEdit"
                          style="width: 200px;"
                          placeholder="请选择第一阶段赛制"
                          clearable
                          @change="changeFirstCompetitionRule(index)"
                        )
                          el-option(
                            v-for="(item, index) in firstCompetitionRuleList"
                            :label="item.label"
                            :value="item.value"
                            :disabled="item.disabled"
                          )
                    div(style="margin-right: 20px; display: flex; align-items: center;")
                      div
                        span(style="margin-right: 41px;") *&nbsp;
                        span 组数：
                      div
                        el-input(
                          v-model="competitionRules[index].groupNum"
                          :disabled="isReviewedEdit || competitionRules[index].FirstCompetition !== 1"
                          style="width: 200px;"
                          placeholder="请填写组数"
                          maxlength="3"
                          clearable
                          @change="changeGroupNum(index)"
                        )
                    div(style="margin-right: 20px; display: flex; align-items: center;")
                      div
                        span *&nbsp;
                        span 第一阶段赛制附加规则：
                      div
                        el-select(
                          v-model="competitionRules[index].allowPlayOff"
                          :disabled="isReviewedEdit || competitionRules[index].FirstCompetition !== 5"
                          style="width: 240px;"
                          placeholder="请选择第一阶段赛制附加规则"
                          clearable
                        )
                          el-option(
                            v-for="(item, index) in firstCompetitionRulePlusList"
                            :label="item.label"
                            :value="item.value"
                          )
                    div(style="display: flex; align-items: center;")
                      div
                        span *&nbsp;
                        span 小组晋级人数：
                      div
                        el-input(
                          v-model="competitionRules[index].groupRiseNum"
                          :disabled="isReviewedEdit || competitionRules[index].FirstCompetition !== 1"
                          style="width: 200px;"
                          placeholder="请填写小组晋级人数"
                          maxlength="3"
                          clearable
                          @change="changeGroupRiseNum(index)"
                        )
                  div(v-if="ruleForm.inGameManagementMode == 1" style="margin-top: 10px; display: flex;")
                    div(style="margin-right: 20px; display: flex; align-items: center;")
                      div
                        span(style="color: red;") *&nbsp;
                        span 第二阶段赛制：
                      div
                        el-select(
                          v-model="competitionRules[index].SecondCompetition"
                          :disabled="isReviewedEdit || competitionRules[index].FirstCompetition !== 1 || Number(competitionRules[index].groupNum) === 1 || !competitionRules[index].groupNum"
                          style="width: 200px;"
                          placeholder="请选择第二阶段赛制"
                          clearable
                          @change="changeSecondCompetitionRule(index)"
                        )
                          el-option(
                            v-for="(item, index) in secondCompetitionRuleList"
                            :label="item.label"
                            :value="item.value"
                          )
                    div(style="margin-right: 20px; display: flex; align-items: center;")
                      div
                        span(style="margin-right: 27px;") *&nbsp;
                        span 交叉数：
                      div
                        el-select(
                          v-model="competitionRules[index].crossNum"
                          :disabled="isReviewedEdit || competitionRules[index].SecondCompetition !== 4"
                          style="width: 200px;"
                          placeholder="请选择交叉数"
                          clearable
                        )
                          el-option(
                            v-for="(item, index) in crossNumList"
                            :label="item.label"
                            :value="item.value"
                          )
                    div(style="margin-right: 20px; display: flex; align-items: center;")
                      div
                        span *&nbsp;
                        span 第二阶段赛制附加规则：
                      div
                        el-select(
                          v-model="competitionRules[index].allowPlayOff1"
                          :disabled="isReviewedEdit || competitionRules[index].SecondCompetition !== 5"
                          style="width: 240px;"
                          placeholder="请选择第二阶段赛制附加规则"
                        )
                          el-option(
                            v-for="(item, index) in firstCompetitionRulePlusList"
                            :label="item.label"
                            :value="item.value"
                            :disabled="item.value === 1 && (Number(competitionRules[index].groupNum) * Number(competitionRules[index].groupRiseNum)) === 2"
                          )

      el-collapse(v-model="activeNames")
        el-collapse-item(title="显示更多", name="1")
          el-form-item(label="重复报名:", prop="repeatSign")
            el-radio(:label=0, v-model="ruleForm.repeatSign") 不允许
            el-radio(:label=1, v-model="ruleForm.repeatSign") 允许
          el-form-item(label="性别限定:", prop="genderLimit")
            el-radio-group(
              v-model="ruleForm.genderLimit",
              @change="genderLimitChange"
            )
              el-radio(:label="2") 全部
              el-radio(:label="0", style="margin-left: 14px") 男
              el-radio(:label="1") 女
          el-form-item(label="年龄限定:")
            font &nbsp;男选手&nbsp;
            el-input-number(
              v-model="ruleForm.ageMinMen",
              :disabled="menDisabled",
              :min=0,
              :max="ageMaxMenMax",
              @change="startAgeMenChange"
            )
            font &nbsp;至&nbsp;
            el-input-number(
              v-model="ruleForm.ageMaxMen",
              :disabled="menDisabled",
              :min="ageMaxMenMin",
              :max=100,
              @change="endAgeMenChange"
            )
            font &nbsp;岁&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;女选手&nbsp;
            el-input-number(
              v-model="ruleForm.ageMinWomen",
              :disabled="womenDisabled",
              :min=0,
              :max="ageMaxWomenMax",
              @change="startAgeWomenChange"
            )
            font &nbsp;至&nbsp;
            el-input-number(
              v-model="ruleForm.ageMaxWomen",
              :disabled="womenDisabled",
              :min="ageMaxWomenMin",
              :max=100,
              @change="endAgeWomenChange"
            )
            font &nbsp;岁
          el-form-item(label="年度积分≥", prop="scoreMin")
            el-input-number(
              v-model="ruleForm.scoreMin",
              :min="0",
              :max="100000000",
              style="margin-left: 50px"
            )
            font.font_later 请限定选手年度积分！
    br
    el-card(shadow="never")
      div(slot="header")
        font(style="font-weight: bold; font-size: 18px") 报名费用
      div
        el-table(:data="ruleForm.ctEnrollPriceList", border)
          el-table-column(prop="name", label="项目", align="center")
          el-table-column(prop="type", label="报名费用", align="center")
            template(slot-scope="scope")
              font ￥&nbsp;&nbsp;
              el-input-number(
                v-model="scope.row.price",
                :precision="2",
                :min="0",
                :max="1000000"
              )
              font &nbsp;&nbsp;&nbsp;&nbsp;元

    br
    el-card(shadow="never")
      div(slot="header")
        font(style="font-weight: bold; font-size: 18px") 退款设置
      div
        el-row(style="padding-bottom: 15px", :span="24")
          el-col(:md="23", :sm="5")
            el-button(@click="addFeeTemplate(2)", type="primary") 选择模板
        el-row
          el-col(:span="8")
            el-form-item(label="距比赛开始≤", label-width="auto")
              el-input-number(
                v-model="ctRefund.minDuration",
                :min="0",
                :max="100000000",
                :step="1"
              )
              font &nbsp;&nbsp;&nbsp;小时
          el-col(:span="8")
            el-form-item(label="退款比例:")
              el-input-number(
                v-model="ctRefund.refundScale",
                :min="0",
                :max="100"
              )
              font &nbsp;&nbsp;&nbsp;%
          el-col(:span="8")
            div(style="float: right")
              el-button(@click="addCtRefund", type="primary") 添 加
              el-button(
                @click="delCtRefund",
                type="danger",
                :disabled="delCtRefundDisabled"
              ) 删 除
        el-table(
          :data="ruleForm.ctRefundList",
          border,
          @selection-change="selectionChangeHandle"
        )
          el-table-column(type="selection", align="center", width="50")
          el-table-column(
            prop="index",
            label="序号",
            align="center",
            width="100"
          )
          el-table-column(
            prop="minDuration",
            label="距比赛开始时间/小时（含）",
            align="center"
          )
          el-table-column(prop="refundScale", label="退款比例/%", align="center")
    br
    el-card(shadow="never")
      div(slot="header")
        font(style="font-weight: bold; font-size: 18px") 电子证书设置
      el-select.sel_width_ct(
        v-model="ruleForm.prizeList",
        clearable,
        placeholder="请选择奖项等级",
        style="margin-bottom: 10px"
      )
        el-option(
          v-for="item in prizeList",
          :label="item.label",
          :value="item.key"
        )
      el-form-item(label="电子证书图:", prop="CertimgList")
        i.el-icon-plus.avatar-uploader-icon(
          style="width: 240px; height: 174px",
          @click="openImgdailog(3)"
        )
        .imagemore
          .imagelist
            .infocont(
              v-for="(item, index) in listImageUrlCert",
              @mouseenter="hoverover(item)",
              @mouseleave="hoverout(item)"
            )
              .deletes(v-if="deletesId === item.imgUrl")
                .Mask
                div
                i(:class="activecolor===item.imgUrl?'el-icon-delete chosecolor':'el-icon-delete'" @mouseenter="hoverover1(item)" @mouseleave="hoverout2(item)" @click="deletecertImg(item,index)")
              div
              img.avatar(
                v-if="listImageUrlCert",
                :src="item.imgUrl",
                style="width: 240px; height: 174px",
                @click="openImgdailog(3)"
              )
              span {{ item.rewardLevel == 1 ? "一等奖" : item.rewardLevel == 2 ? "二等奖" : item.rewardLevel == 3 ? "三等奖" : item.rewardLevel == 4 ? "四等奖" : "" }}
            div
          div
        div
        imguploadMD(
          v-if="openImg",
          ref="upimg3",
          :width="240",
          :height="174",
          @uploadSuccess="doneup_Cert"
        )
      el-alert(
        title="建议最小分辨率240×175,上传图片格式仅支持jpg,jpeg,png,大小不超过10M",
        effect="light",
        :closable="false",
        style="margin-top: 10px"
      )
  span.dialog-footer(slot="footer")
    el-button(type="primary", @click="ruleFormSubmit()", :disabled="clickFlag") 确 定
    el-button(@click="closeForm()") 取 消
  //- 选择模板
  addFeeTemplate(
    v-if="addFeeTemplateVisible",
    ref="addFeeTemplate",
    @chooseTemplate="chooseTemplate"
  )
</template>

<script>
import util from '@/libs/util.js';
import addFeeTemplate from '../../../operation/fee/add-fee-template.vue';
import { commomDictData } from '@/util/dictionary'; // 字典项
export default {
  components: {
    addFeeTemplate,
  },
  data () {
    var matchDscRule = (rule, value, callback) => {
      if (!value || value === '<p><br></p>') {
        callback(new Error('比赛简介不能为空!'));
      } else {
        callback();
      }
    };
    return {
      pdfs: [],
      // 审核状态编辑？
      isReviewedEdit: false,
      // 比赛赛制 为0时不可编辑
      isInGameManagementMode: false,
      uploadHeader: {
        Accept: 'application/json, text/plain, */*',
        token: util.cookies.get('token'),
        authorization: 'Bearer ' + util.cookies.get('authorization'),
        // 'Content-Type': 'application/json; charset=utf-8'
      },
      pdfUrl: '',
      uploadData: {
        type: 'ctLevel',
      },
      disabedJY: true,
      disabedTT: false,
      checkedCities: [],
      cities: [
        { label: '1', value: '甲A', disabed: true },
        { label: '2', value: '甲B', disabed: true },
        { label: '3', value: '乙A', disabed: true },
        { label: '4', value: '乙B', disabed: true },
        { label: '5', value: '丙A', disabed: true },
        { label: '6', value: '丙B', disabed: true },
        { label: '7', value: '丁A', disabed: true },
        { label: '8', value: '丁B', disabed: true },
        { label: '9', value: '资格甲', disabed: true },
        { label: '10', value: '资格乙', disabed: true },
        { label: '11', value: '资格丙', disabed: true },
        { label: '12', value: '资格丁', disabed: true }
      ],
      activecolor: -1,
      deletesId: -1,
      activeNames: ['0'],
      ctRefund: {
        index: 0,
        minDuration: 0,
        refundScale: 0,
      },
      defaultTime: [],
      defaultValue: [],
      defaultValue1: [],
      addFeeTemplateVisible: false,
      teamMaxSelect: 100,
      teamMinSelect: 0,
      clickFlag: false,
      delTableList: [],
      sysOrgList: [],
      cityList: [],
      provinceList: [],
      delCtRefundDisabled: true,
      cityDisbaled: true,
      provinceDisabled: true,
      nameFont: 40,
      venueIdDisabled: true,
      venueList: [],
      placesInfoList: [],
      ageMaxMenMin: 0,
      ageMaxWomenMin: 0,
      ageMaxMenMax: 100,
      ageMaxWomenMax: 100,
      menDisabled: false,
      womenDisabled: false,
      ruleForm: {
        outcomeType: 0,
        ifDoublePoint: 0,
        id: null,
        clubLimit: '',
        matchType: '2',
        matchId: '',
        matchName: '',
        userGroupId: '',
        cityCode: '',
        cityName: '',
        provinceCode: '',
        provinceName: '',
        venueId: '',
        ctType: '',
        applySize: '',
        teamMin: 6,
        teamMax: 9,
        startScore: 0, //起始点
        championAddPoints: 0, //冠军加分
        applyDate: [],
        AttendanceList: [], //出场名单
        RegistrationList: [], //报名名单
        presidentLimit: 1,
        matchSignStartTime: null,
        matchSignEndTime: null,
        matchStartTime: null,
        imgList: '',
        gameDescription: '',
        matchDescription: '',
        imgDetailList: '',
        repeatSign: 1,
        genderLimit: 2,
        ageLimit: '',
        ageMinMen: undefined,
        ageMaxMen: undefined,
        ageMinWomen: undefined,
        ageMaxWomen: undefined,
        scoreMin: 0,
        venueAddress: '',
        ctRefundList: [],
        ctEnrollPriceList: [
          {
            id: null,
            name: '团队费用',
            price: 0.0,
          },
        ],
        inGameManagementMode: 1,
        placeInfo: '',
        __placeInfoTemp__: [],
        competitionClub: {
          adjustAppearListStartTime: '',
          adjustAppearListEndTime: '',
          adjustEnrollListStartTime: '',
          adjustEnrollListEndTime: '',
          sixthMan: 1,
        },
        contactMobile: '',
        changeSignStartTime: null,
        changeSignEndTime: null,
        changeShowStartTime: null,
        changeShowEndTime: null,
        // recommend: 1, // 是否首页推荐
        sixthPerson: 1, // 是否第六人
        matchFormat: '', // 赛制
        firstFormat: null,
        ecertList: [], //电子证书设置
        personPointsRules: 0, // 个人参与积分规则 0-不计算 1-计算
        personWinPoints: 0, // 个人胜利加分
        personFailPoints: 0, // 个人失败加分
        personAbandonPoints: 0, // 个人弃权加分
        clubPointsRules: 0, // 俱乐部参与积分规则 0-不计算 1-计算
        clubWinPoints: 0, // 俱乐部胜利加分
        clubFailPoints: 0, // 俱乐部失败加分
        clubAbandonPoints: 0, // 俱乐部弃权加分
      },
      NumberList: [
        { key: 2, label: '2名' },
        { key: 4, label: '4名' },
        { key: 6, label: '6名' },
        { key: 8, label: '8名' },
      ],
      prizeList: [
        { key: 1, label: '一等奖' },
        { key: 2, label: '二等奖' },
        { key: 3, label: '三等奖' },
        { key: 4, label: '四等奖' },
      ],
      pointsRulesList: [
        { key: 0, label: '不计算' },
        { key: 1, label: '计算' }
      ],
      listImageUrlCert: [],
      flagType: '',
      loading: null,
      ctDisabled: true,
      matchStartTimePlaceholder: '必须先选择报名时间',
      pickerOptions: {
        // disabledDate: (time) => {
        //   return time <= new Date() - 1000 * 60 * 59 * 24
        // }
      },
      pickerOptionsCt: null,
      pickerOptionsCt1: null,
      pickerOptionsCt2: null,
      rules: {
        matchName: [
          { required: true, message: '比赛名称不能为空!', trigger: 'blur' },
          { max: 40, message: '长度不能超过40个字符!' }
        ],
        ifDoublePoint: [
          { required: true, message: '积分配置不能为空!', trigger: 'blur' }
        ],
        userGroupId: [
          { required: true, message: '主办方不能为空!', trigger: 'change' }
        ],
        venueId: [
          { required: true, message: '主办场地不能为空!', trigger: 'change' }
        ],
        ctType: [
          { required: true, message: '比赛类型不能为空!', trigger: 'change' }
        ],
        outcomeType: [
          { required: true, message: '胜负方判定方式不能为空!', trigger: 'change' }
        ],
        applySize: [
          { required: true, message: '签位不能为空!', trigger: 'blur' },
          { max: 10, message: '签位不能超过10个字符!', trigger: 'blur' },
          { pattern: /^[0-9]*[1-9][0-9]*$/, message: '请输入正整数', trigger: 'blur' }
        ],
        inGameManagementMode: [
          { required: true, message: '赛中管理模式不能为空!', trigger: 'change' }
        ],
        applyDate: [
          { required: true, message: '报名时间不能为空!', trigger: 'change' }
        ],
        RegistrationList: [
          { required: true, message: '调整报名名单时间不能为空!', trigger: 'change' }
        ],
        AttendanceList: [
          { required: true, message: '调整出场名单时间不能为空!', trigger: 'change' }
        ],
        matchStartTime: [
          { required: true, message: '比赛时间不能为空!', trigger: 'blur' }
        ],
        matchDescription: [
          { required: true, validator: matchDscRule, trigger: 'change' }
        ],
        startScore: [
          { required: true, message: '积分起始点不能为空!', trigger: 'change' }
        ],
        personPointsRules: [
          { required: true, message: '请选择个人参与积分规则!', trigger: 'change' }
        ],
        clubPointsRules: [
          { required: true, message: '请选择俱乐部参与积分规则!', trigger: 'change' }
        ],
        contactMobile: [
          {
            required: false,
            validator: (rule, value, callback) => {
              if (value && !/^\d{11}$/.test(value)) {
                callback(new Error('请输入正确的联系电话!'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      },
      visible: false,
      listImageUrl: '',
      detailImageUrl: '',
      openImg: '',
      gameSystems: [], // 赛制
      showQuill: false, // 这个字段是用来解决Quill富文本编辑器在初始化后会自动聚焦从而导致页面自动滚动的bug

      competitionRulesTab: '',
      competitionRules: [],
      firstCompetitionRuleList: [
        { value: 0, label: '淘汰附加赛' },
        { value: 1, label: '小组循环赛' },
        { value: 5, label: '淘汰赛' },
				{ value: 7, label: '俱乐部队队碰赛', disabled: true }
      ],
      firstCompetitionRulePlusList: [
        { label: '第三四名争夺季军', value: 1 },
        { label: '无附加赛', value: 0 }
      ],
      secondCompetitionRuleList: [
        { value: 2, label: '同名次小组循环赛' },
        { value: 3, label: '同名次淘汰附加赛' },
        { value: 4, label: '交叉淘汰附加赛' },
        { value: 5, label: '淘汰赛' }
      ],
      crossNumList: [
        { value: 2, label: '2' }
      ]
    }
  },
  mounted () {
    //this.restaurants = this.loadAll()
    this.initCity();
    // 获取赛制属性列表(字典项) // E_CERT_ REWARD_LEVEL 电子证书 MATCH_FORMAT 赛制
    commomDictData('MATCH_FORMAT', this).then((res) => {
      this.gameSystems = res.list;
    });
  },
  computed: {
    disabledClubPointsRules () {
      return this.ruleForm.clubPointsRules === 0
    },
    disabledPersonPointsRules () {
      return this.ruleForm.personPointsRules === 0
    }
  },
  methods: {
    openForm () {
      this.pdfs = [];
    },
    handleLoading (file) {
      for (let i = 0; i < this.pdfs.length; i++) {
        if (this.pdfs[i].fileName == file.name) {
          this.$message.error('文件已存在');
          return false;
        }
      }
      let files = file.name.split('.');
      let fileSuffix = files[files.length - 1];
      if (fileSuffix != 'pdf' && fileSuffix != 'doc' && fileSuffix != 'docx') {
        this.$message.error('只能上传pdf，doc和docx格式的文档');
        return false;
      }
      let pdf = {};
      pdf.fileName = file.name;
      pdf.url = '';
      pdf.loading = 0;
      pdf.loaded = false;
      this.pdfs.push(pdf);
      let timer = setInterval(() => {
        if (pdf.loaded) {
          clearInterval(timer);
          pdf.loading = 100;
        } else {
          if (pdf.loading < 99) {
            pdf.loading++;
          }
        }
      }, 100);
    },
    deletePdf (index) {
      let tips = '确定删除？';
      this.$confirm(tips, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.pdfs.splice(index, 1);
          this.$message.success('已删除');
        })
        .catch(() => {
          this.$message.info('已取消！');
        });
    },
    savePdfUrl (res, file, fileList) {
      this.$message.success('上传成功');
      for (let i = 0; i < this.pdfs.length; i++) {
        if (this.pdfs[i].fileName == res.bean.fileName) {
          this.pdfs[i].url = res.path + res.bean.url;
          this.pdfs[i].loading = 100;
          this.pdfs[i].ossId = res.bean.id;
          this.pdfs[i].loaded = true;
          return 0;
        }
      }
    },
    loadingFail () {
      this.$message.error('上传失败');
    },
    changectType (value) {
      if (value === 5) {
        this.checkedCities = ['9', '10', '11', '12'];
        this.changeclubLimit(this.checkedCities);
        for (let i = 0; i < this.cities.length; i++) {
          if (i > 7) {
            this.cities[i].disabed = false;
          } else {
            this.cities[i].disabed = true;
          }
        }
      }
      if (value === 6) {
        this.checkedCities = ['1', '2', '3', '4', '5', '6', '7', '8'];
        this.changeclubLimit(this.checkedCities);
        for (let i = 0; i < this.cities.length; i++) {
          if (i < 8) {
            this.cities[i].disabed = false;
          } else {
            this.cities[i].disabed = true;
          }
        }
      }
      this.competitionRulesTab = this.checkedCities[0]
    },
    handleCheckedCitiesChange (value) {
      this.changeclubLimit(value);
    },
    changeclubLimit (value) {
      let arr = '';
      value.forEach((item, index) => {
        if (index == 0) {
          arr = item;
        } else {
          arr = arr + ',' + item;
        }
      });
      this.ruleForm.clubLimit = arr;
    },
    changeappsize (flag = '') {
      if (flag || flag === 0) {
        // "级别队伍数" === 2 时, 就可以选择"俱乐部对对碰赛"了
        if (Number(this.competitionRules[flag].teamNum) === 2) {
          this.firstCompetitionRuleList[3].disabled = false
        } else {
          this.firstCompetitionRuleList[3].disabled = true
        }

        // 如果"级别队伍数" !== 2, 并且第一阶段赛制选择了"俱乐部对对碰赛", 则需要将"第一阶段赛制"清空, 因为"级别队伍数" === 2 时才能选择"俱乐部对对碰赛"
        if (Number(this.competitionRules[flag].teamNum) !== 2 && this.competitionRules[flag].FirstCompetition === 7) {
          this.competitionRules[flag].FirstCompetition = ''
        }

        // "签位数" 必须为 "级别队伍数量" 的倍数
        // if (Number(this.ruleForm.applySize) % Number(this.competitionRules[flag].teamNum) !== 0) {
        //   this.$confirm('当前系统支持签位数必须为级别队伍数量的倍数，请重新设置！', '提示', {
        //     showCancelButton: false,
        //     confirmButtonText: '确定',
        //     type: 'warning'
        //   })
        // }

        // ctType === 5 挑战赛时, 总分组 (签位 / 级别队伍数) 应 <= 4
        // if (this.ruleForm.ctType === 5 && (Number(this.competitionRules[flag].teamNum) || Number(this.competitionRules[flag].teamNum) === 0)) {
        //   if (this.ruleForm.applySize / Number(this.competitionRules[flag].teamNum) > 4) {
        //     this.$confirm('挑战赛事总分组（即总签位 / 级别队伍数）应不大于4，请重新设置！', '提示', {
        //       showCancelButton: false,
        //       confirmButtonText: '确定',
        //       type: 'warning'
        //     })
        //   }
        // }

        // ctType === 6 群英赛, 总分组 (签位 / 级别队伍数) 应 <= 8
        // if (this.ruleForm.ctType === 6 && (Number(this.competitionRules[flag].teamNum) || Number(this.competitionRules[flag].teamNum) === 0)) {
        //   if (this.ruleForm.applySize / Number(this.competitionRules[flag].teamNum) > 8) {
        //     this.$confirm('群英赛事总分组（即总签位 / 级别队伍数）应不大于8，请重新设置！', '提示', {
        //       showCancelButton: false,
        //       confirmButtonText: '确定',
        //       type: 'warning'
        //     })
        //   }
        // }
      }
    },
    // 修改"第一阶段赛制"时触发
    changeFirstCompetitionRule (flag) {
      this.competitionRules[flag].groupNum = ''
      this.competitionRules[flag].allowPlayOff = ''
      this.competitionRules[flag].groupRiseNum = ''
      this.competitionRules[flag].SecondCompetition = ''
      this.competitionRules[flag].crossNum = ''
      this.competitionRules[flag].allowPlayOff1 = ''

      // 俱乐部对对碰赛
      if (this.competitionRules[flag].FirstCompetition === 7) {
        this.competitionRules[flag].groupNum = 1 // 组数
      }

      // 淘汰赛
      if (this.competitionRules[flag].FirstCompetition === 5) {
        this.competitionRules[flag].allowPlayOff = 0
      }
    },
    changeGroupNum (flag = '') {
      if (flag || flag === 0) {
        // 组数 === 1 || 组数为空
        if (this.competitionRules[flag].groupNum == 1 || this.competitionRules[flag].groupNum == '') {
          this.competitionRules[flag].SecondCompetition = '' // 清空第二阶段赛制
          this.competitionRules[flag].crossNum = '' // 清空交叉数
          this.competitionRules[flag].allowPlayOff1 = '' // 清空第二阶段赛制附加规则
        }

        // 第二赛制为 同名次小组循环赛
        if (this.competitionRules[flag].SecondCompetition === 2) {
          // 组数 < 2 && 组数 > 6
          if (this.competitionRules[flag].groupNum < 2 || this.competitionRules[flag].groupNum > 6) {
            this.$confirm('因第二阶段同名次小组循环赛系统支持2-6签的小组对阵，故第一阶段小组循环赛分组数也需满足2-6组，请重新设置组数！', '提示', {
              showCancelButton: false,
              confirmButtonText: '确定',
              type: 'warning'
            })
          }
        }

        if (
          this.competitionRules[flag].allowPlayOff1 === 1 &&
          (Number(this.competitionRules[flag].groupNum) * Number(this.competitionRules[flag].groupRiseNum) === 2) &&
          this.competitionRules[flag].SecondCompetition === 5
        ) {
          this.$confirm('第一阶段小组晋级人数导致第二阶段参赛队伍为2支，第二阶段赛制附加规则请选择“无附加赛”！', '提示', {
            showCancelButton: false,
            confirmButtonText: '确定',
            type: 'warning'
          })
        }
      }
    },
    // 修改"第一阶段小组晋级人数"时触发
    changeGroupRiseNum (flag) {
      // 签位 和 组数 都已填写
      if (this.competitionRules[flag].teamNum && this.competitionRules[flag].groupNum) {
        // 第一阶段小组晋级人数 > 每组人数
        if (Number(this.competitionRules[flag].groupRiseNum) > (Number(this.competitionRules[flag].teamNum) / Number(this.competitionRules[flag].groupNum))) {
          this.$confirm('第一阶段小组晋级人数不能超过小组人数，请重新设置！', '提示', {
            showCancelButton: false,
            confirmButtonText: '确定',
            type: 'warning'
          })
        }
      }

      if (
        this.competitionRules[flag].allowPlayOff1 === 1 &&
        (Number(this.competitionRules[flag].groupNum) * Number(this.competitionRules[flag].groupRiseNum) === 2) &&
        this.competitionRules[flag].SecondCompetition === 5
      ) {
        this.$confirm('第一阶段小组晋级人数导致第二阶段参赛队伍为2支，第二阶段赛制附加规则请选择“无附加赛”！', '提示', {
          showCancelButton: false,
          confirmButtonText: '确定',
          type: 'warning'
        })
      }
    },
    // 修改"第二阶段赛制"时触发
    changeSecondCompetitionRule (flag) {
      this.competitionRules[flag].crossNum = ''
      this.competitionRules[flag].allowPlayOff1 = ''

      // 第二赛制为"同名次小组循环赛"
      if (this.competitionRules[flag].SecondCompetition === 2) {
        // 组数 < 2 && 组数 > 6
        if (this.competitionRules[flag].groupNum < 2 || this.competitionRules[flag].groupNum > 6) {
          this.$confirm('因第二阶段同名次小组循环赛系统支持2-6签的小组对阵，故第一阶段小组循环赛分组数也需满足2-6组，请重新设置组数！', '提示', {
            showCancelButton: false,
            confirmButtonText: '确定',
            type: 'warning'
          })
        }
      }

      // 第二阶段赛制为"淘汰赛"
      if (this.competitionRules[flag].SecondCompetition === 5) {
        this.competitionRules[flag].allowPlayOff1 = 1 // 第二阶段赛制附加规则为"第三四名争夺季军"
      }

      if (
        this.competitionRules[flag].allowPlayOff1 === 1 &&
        (Number(this.competitionRules[flag].groupNum) * Number(this.competitionRules[flag].groupRiseNum) === 2) &&
        this.competitionRules[flag].SecondCompetition === 5
      ) {
        this.$confirm('第一阶段小组晋级人数导致第二阶段参赛队伍为2支，第二阶段赛制附加规则请选择“无附加赛”！', '提示', {
          showCancelButton: false,
          confirmButtonText: '确定',
          type: 'warning'
        })
      }
    },
    // 删除电子证书
    deletecertImg (item, index) {
      this.listImageUrlCert.splice(index, 1);
    },
    // 鼠标移入
    hoverover (item) {
      this.deletesId = item.imgUrl;
    },
    hoverover1 (item) {
      this.activecolor = item.imgUrl;
      // this.$nextTick(() => {
      //   this.activecolor = item.id
      // })
      // this.$set(this.activecolor, item.id)
    },
    // 鼠标移出
    hoverout (item) {
      this.deletesId = -1;
    },
    hoverout2 (item) {
      this.activecolor = -1;
    },
    teamMaxChange (value) {
      this.teamMinSelect = value;
    },
    teamMinChange (value) {
      this.teamMaxSelect = value;
    },
    // 数据初始化
    initRuleForm () {
      this.ruleForm = {
        outcomeType: 0,
        ifDoublePoint: 0,
        id: null,
        clubLimit: '',
        matchType: '2',
        matchId: '',
        matchName: '',
        userGroupId: '',
        cityCode: '',
        cityName: '',
        provinceCode: '',
        provinceName: '',
        venueId: '',
        ctType: '',
        applySize: '',
        teamMin: 6,
        teamMax: 9,
        startScore: 0, //起始点
        championAddPoints: 0, //冠军加分
        applyDate: [],
        AttendanceList: [], //出场名单
        RegistrationList: [], //报名名单
        presidentLimit: 1,
        matchSignStartTime: null,
        matchSignEndTime: null,
        matchStartTime: null,
        imgList: '',
        gameDescription: '',
        matchDescription: '',
        imgDetailList: '',
        repeatSign: 1,
        genderLimit: 2,
        ageLimit: '',
        ageMinMen: undefined,
        ageMaxMen: undefined,
        ageMinWomen: undefined,
        ageMaxWomen: undefined,
        scoreMin: 0,
        venueAddress: '',
        ctRefundList: [],
        ctEnrollPriceList: [
          {
            id: null,
            name: '团队费用',
            price: 0.0,
          },
        ],
        inGameManagementMode: 1,
        placeInfo: '',
        __placeInfoTemp__: [{ name: '' }],
        competitionClub: {
          adjustAppearListStartTime: '',
          adjustAppearListEndTime: '',
          adjustEnrollListStartTime: '',
          adjustEnrollListEndTime: '',
          sixthMan: 1,
        },
        contactMobile: '',
        changeSignStartTime: null,
        changeSignEndTime: null,
        changeShowStartTime: null,
        changeShowEndTime: null,
        // recommend: 1, // 是否首页推荐
        sixthPerson: 1, // 是否第六人
        matchFormat: '', // 赛制
        firstFormat: null,
        ecertList: [], //电子证书设置
        personPointsRules: 0, // 个人参与积分规则 0-不计算 1-计算
        personWinPoints: 0, // 个人胜利加分
        personFailPoints: 0, // 个人失败加分
        personAbandonPoints: 0, // 个人弃权加分
        clubPointsRules: 0, // 俱乐部参与积分规则 0-不计算 1-计算
        clubWinPoints: 0, // 俱乐部胜利加分
        clubFailPoints: 0, // 俱乐部失败加分
        clubAbandonPoints: 0, // 俱乐部弃权加分
      }
    },
    init (id, flagType) {
      this.visible = true;
      this.initRuleForm()
      this.clickFlag = false;
      this.flagType = flagType;
      this.ruleForm.id = id || null;
      this.$nextTick(() => {
        this.$refs['ruleForm'].resetFields();
        this.$refs['d2-quill'].Quill.pasteHTML('');
        this.$refs.gameDescription.Quill.pasteHTML('');
      });
      //数据初始化
      this.isReviewedEdit = false;
      this.isInGameManagementMode = false;
      this.ctDisabled = true;
      this.matchStartTimePlaceholder = '必须先选择报名时间';
      this.listImageUrl = '';
      this.detailImageUrl = '';
      this.ruleForm.placeInfo = ''
      this.ruleForm.__placeInfoTemp__ = [{ name: '' }]
      this.ruleForm.ageMinMen = undefined;
      this.ruleForm.ageMaxMen = undefined;
      this.ruleForm.ageMinWomen = undefined;
      this.ruleForm.ageMaxWomen = undefined;
      this.ctRefund.minDuration = 0;
      this.ctRefund.refundScale = 0;
      this.ctRefund.index = 0;
      this.ruleForm.competitionClub = {
        adjustAppearListStartTime: '',
        adjustAppearListEndTime: '',
        adjustEnrollListStartTime: '',
        adjustEnrollListEndTime: '',
        sixthMan: 1,
      };
      this.ruleForm.ctRefundList = [];
      this.delTableList = [];
      this.ruleForm.matchSignStartTime = '';
      this.ruleForm.matchSignEndTime = '';
      this.ruleForm.AttendanceList = [];
      this.ruleForm.RegistrationList = [];
      this.listImageUrlCert = [];
      this.selClear();
      this.cityDisbaled = true;
      this.provinceDisabled = true;
      this.venueIdDisabled = true;
      this.womenDisabled = false;
      this.menDisabled = false;
      this.nameFont = 40;
      this.$nextTick(() => {
        this.pickerOptionsCt = null;
        this.pickerOptionsCt1 = null;
        this.pickerOptionsCt2 = null;
      });

      this.competitionRules = []
      this.cities.forEach(item => {
        this.competitionRules.push({
          // id: '',
          ctId: '',
          groupCode: item.label,
          groupName: item.value,
          groupNickname: '',
          teamNum: '',
          FirstCompetition: '',
          groupNum: '',
          allowPlayOff: '',
          groupRiseNum: '',
          SecondCompetition: '',
          crossNum: '',
          allowPlayOff1: ''
        })
      })

      this.dataInit();
      setTimeout(() => {
        this.showQuill = true
      }, 1000)
      //修改回选
      if (this.ruleForm.id) {
        this.$http({
          url: this.$http.adornUrl(`/ctCompetition/getId/` + this.ruleForm.id),
          method: 'get',
        }).then((data) => {
          if (data && data.code === 0) {
            this.changeCity(data.bean.userGroupId);
            this.genderLimitChange(data.bean.genderLimit);
            this.pdfs = data.bean.attachmentsList ? data.bean.attachmentsList : [];
            if (this.pdfs.length > 0) {
              for (let i = 0; i < this.pdfs.length; i++) {
                this.pdfs[i].loading = 100;
              }
            }
            this.ruleForm = data.bean;
            this.ruleForm.ifDoublePoint = data.bean.competitionClub.ifDoublePoint;
            if (this.ruleForm.competitionClub) {
              this.ruleForm.competitionClub.sixthMan = this.ruleForm.competitionClub.sixthMan ? 1 : 0;
            } else {
              this.ruleForm.competitionClub = { sixthMan: -1 }; //默认是否第六人为1
            }
            // 俱乐部等级
            if (data.bean.clubLimit) {
              this.checkedCities = data.bean.clubLimit.split(',');
              if (this.ruleForm.ctType == 5) {
                for (let i = 0; i < this.cities.length; i++) {
                  if (i > 7) {
                    this.cities[i].disabed = false;
                  } else {
                    this.cities[i].disabed = true;
                  }
                }
              } else {
                for (let i = 0; i < this.cities.length; i++) {
                  if (i < 8) {
                    this.cities[i].disabed = false;
                  } else {
                    this.cities[i].disabed = true;
                  }
                }
              }
              this.competitionRulesTab = this.checkedCities[0]
            }
            this.listImageUrl = data.bean.imgUrlList;
            this.detailImageUrl = data.bean.imgUrlDetail;
            this.changeProvice(0);
            this.selectCity(0);
            this.dataInit();
            this.nameFont = 40 - data.bean.matchName.length;
            this.ruleForm.recommend = data.bean.recommend;
            this.ruleForm.applyDate = [];
            this.ruleForm.applyDate.push(data.bean.matchSignStartTime + '');
            this.ruleForm.applyDate.push(data.bean.matchSignEndTime + '');
            this.$set(this.ruleForm, '__placeInfoTemp__', data.bean.placeInfo.split(',').map(item => { return { name: item } }))

            this.ruleForm.ctEnrollPriceList = data.eList;
            // this.listImageUrlCert = data.bean.
            if (data.bean.ecertList.length > 0) {
              data.bean.ecertList.forEach((element) => {
                let come = {
                  imgUrl: '',
                  rewardLevel: '',
                };
                come.rewardLevel = element.rewardLevel;
                come.imgUrl = element.imgUrl;
                this.listImageUrlCert.push(come);
              });
            }
            // this.ruleForm.RegistrationList.push(data.bean.competitionClub.adjustAppearListStartTime)
            // this.ruleForm.RegistrationList.push(data.bean.competitionClub.adjustAppearListEndTime)
            // this.ruleForm.AttendanceList.push(data.bean.competitionClub.adjustEnrollListStartTime)
            // this.ruleForm.AttendanceList.push(data.bean.competitionClub.adjustEnrollListEndTime)
            this.ruleForm.RegistrationList = [];
            this.ruleForm.AttendanceList = [];
            if (data.bean.competitionClub != null) {
              this.ruleForm.RegistrationList.push(data.bean.competitionClub.adjustAppearListStartTime + '');
              this.ruleForm.RegistrationList.push(data.bean.competitionClub.adjustAppearListEndTime + '');
              this.ruleForm.AttendanceList.push(data.bean.competitionClub.adjustEnrollListStartTime + '');
              this.ruleForm.AttendanceList.push(data.bean.competitionClub.adjustEnrollListEndTime + '');
              this.ruleForm.competitionClub.sixthMan = data.bean.competitionClub.sixthMan ? 1 : 0;
            }

            // 新数据
            if (data.bean.competitionMatchFormatGroupList && data.bean.competitionMatchFormatGroupList.length > 0) {
              this.competitionRules.forEach(item => {
                data.bean.competitionMatchFormatGroupList.forEach(one => {
                  if (Number(item.groupCode) === one.groupCode) {
                    if (one.stage === 1) {
                      // item.id = this.flagType === 2 ? '' : one.id
                      item.ctId = this.flagType === 2 ? '' : one.ctId
                      item.groupNickname = one.groupNickname
                      item.teamNum = one.levelNum
                      item.FirstCompetition = one.matchFormat
                      item.groupNum = one.groupNum || ''
                      item.allowPlayOff = one.allowPlayOff
                      item.groupRiseNum = one.groupRiseNum || ''
                    }
                    if (one.stage === 2) {
                      item.SecondCompetition = one.matchFormat
                      item.crossNum = one.crossNum
                      item.allowPlayOff1 = one.allowPlayOff
                    }
                  }
                })
              })
            } else { // 老数据
              for (let i = 0; i < this.cities.length; i++) {
                if (!this.cities[i].disabed && this.checkedCities.includes(this.cities[i].label)) {
                  // this.competitionRules[i].id = this.flagType === 2 ? '' : data.bean.competitionMatchFormatList[0].id
                  this.competitionRules[i].ctId = this.flagType === 2 ? '' : data.bean.competitionMatchFormatList[0].ctId
                  this.competitionRules[i].groupNickname = data.bean.competitionMatchFormatList[0].groupNickname || ''
                  this.competitionRules[i].teamNum = data.bean.teamNum || ''
                  this.competitionRules[i].FirstCompetition = data.bean.competitionMatchFormatList[0].matchFormat || ''
                  this.competitionRules[i].groupNum = data.bean.competitionMatchFormatList[0].groupNum || ''
                  this.competitionRules[i].allowPlayOff = data.bean.competitionMatchFormatList[0].allowPlayOff || 0
                  this.competitionRules[i].groupRiseNum = data.bean.competitionMatchFormatList[0].groupRiseNum || ''
                  this.competitionRules[i].SecondCompetition = data.bean.competitionMatchFormatList[1].matchFormat || ''
                  this.competitionRules[i].crossNum = data.bean.competitionMatchFormatList[1].crossNum || ''
                  this.competitionRules[i].allowPlayOff1 = data.bean.competitionMatchFormatList[1].allowPlayOff || 0
                }
              }
            }

            this.ruleForm.ctRefundList = [];
            let index = 1;

            if (data.rList.length > 0) {
              for (let i of data.rList) {
                this.ruleForm.ctRefundList.push({
                  index: index++,
                  minDuration: i.minDuration,
                  refundScale: i.refundScale,
                });
              }
            }
            this.ctDisabled = false;
            // 非未审核状态编辑（部分控制不可修改）
              if (flagType === 'reviewedEdit') {
                this.isReviewedEdit = true
                if (this.ruleForm.inGameManagementMode == 0) {
                  this.isInGameManagementMode = true
                } else {
                  this.isInGameManagementMode = false
                }
              }
            this.$nextTick(() => {
              this.$refs['d2-quill'].Quill.pasteHTML(
                data.bean.matchDescription
              );
              this.$refs.gameDescription.Quill.pasteHTML(
                data.bean.gameDescription
              );
            });
          }
        });
      }
    },
    selectCity (flag) {
      if (flag !== 0) {
        this.venueList = [];
        this.ruleForm.venueId = '';
      }
      this.$http({
        url: this.$http.adornUrl('/pbPlaces/getPlaceById'),
        method: 'get',
        params: this.$http.adornParams({
          orgId: this.ruleForm.userGroupId,
          proviceId: this.ruleForm.provinceCode,
          cityId: this.ruleForm.cityCode,
        }),
      }).then((data) => {
        let obj = {};
        let val = this.ruleForm.cityCode;
        if (val) {
          obj = this.cityList.find((item) => {
            return item.citycode === val;
          });
          if (obj) {
            this.ruleForm.cityName = obj.cityname;
          }
        }
        this.venueList = data && data.code === 0 ? data.list : [];
      });
    },
    changeProvice (flag) {
      if (flag !== 0) {
        this.cityList = [];
        this.ruleForm.cityCode = '';
        this.venueList = [];
        this.ruleForm.venueId = '';
      }
      this.$http({
        url: this.$http.adornUrl('/dicProvinceCity/queryByOrgId'),
        method: 'get',
        params: this.$http.adornParams({
          orgId: this.ruleForm.userGroupId,
          provinceCode: this.ruleForm.provinceCode,
        }),
      }).then((data) => {
        let obj = {};
        let val = this.ruleForm.provinceCode;
        if (val) {
          obj = this.provinceList.find((item) => {
            return item.code === val;
          });
          if (obj) {
            this.ruleForm.provinceName = obj.name;
          }
        }
        this.cityList = data.list;
      });
    },
    dataInit () {
      this.ruleForm.ctEnrollPriceList = [
        {
          name: '团队费用',
          price: 0.0,
        },
      ];
    },
    descInput () {
      let len = 40 - this.ruleForm.matchName.length;
      this.nameFont = len;
    },
    openFullScreen () {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
    },
    //新增方法
    ruleFormSubmit () {
      this.$refs['ruleForm'].validate((valid) => {
        // 赛制相关数据校验
        let teamNumAll = 0
        const matchFormatArr = []
        for (let i = 0; i < this.cities.length; i++) {
          if (!this.cities[i].disabed && this.checkedCities.includes(this.cities[i].label) && this.competitionRules[i].teamNum) {
            // ==================================================级别队伍数==================================================
            if (
              !Number.isInteger(Number(this.competitionRules[i].teamNum)) ||
              Number(this.competitionRules[i].teamNum) <= 0
            ) {
              return this.$confirm(`请确认${this.cities[i].value}的级别队伍数是否填写正确！`, '提示', {
                showCancelButton: false,
                confirmButtonText: '确定',
                type: 'warning'
              })
            }

            teamNumAll += Number(this.competitionRules[i].teamNum)

            // "签位数" 必须为 "级别队伍数量" 的倍数
            // if (Number(this.ruleForm.applySize) % Number(this.competitionRules[i].teamNum) !== 0) {
            //   return this.$confirm(`当前系统支持签位数必须为级别队伍数量的倍数，请重新设置${this.cities[i].value}的级别队伍数！`, '提示', {
            //     showCancelButton: false,
            //     confirmButtonText: '确定',
            //     type: 'warning'
            //   })
            // }

            // ctType === 5 挑战赛时, 总分组 (签位 / 级别队伍数) 应 <= 4
            // if (this.ruleForm.ctType === 5) {
            //   if (this.ruleForm.applySize / Number(this.competitionRules[i].teamNum) > 4) {
            //     return this.$confirm(`挑战赛事总分组（即总签位 / 级别队伍数）应不大于4，请重新设置${this.cities[i].value}的级别队伍数！`, '提示', {
            //       showCancelButton: false,
            //       confirmButtonText: '确定',
            //       type: 'warning'
            //     })
            //   }
            // }

            // ctType === 6 群英赛, 总分组 (签位 / 级别队伍数) 应 <= 8
            // if (this.ruleForm.ctType === 6) {
            //   if (this.ruleForm.applySize / Number(this.competitionRules[i].teamNum) > 8) {
            //     return this.$confirm(`群英赛事总分组（即总签位 / 级别队伍数）应不大于8，请重新设置${this.cities[i].value}的级别队伍数！`, '提示', {
            //       showCancelButton: false,
            //       confirmButtonText: '确定',
            //       type: 'warning'
            //     })
            //   }
            // }
            // ==================================================级别队伍数==================================================

            if (!this.competitionRules[i].FirstCompetition && this.competitionRules[i].FirstCompetition !== 0) {
              return this.$confirm(`请选择${this.cities[i].value}的第一阶段赛制！`, '提示', {
                showCancelButton: false,
                confirmButtonText: '确定',
                type: 'warning'
              })
            }

            // 小组循环赛
            if (this.competitionRules[i].FirstCompetition === 1) {
              // 组数
              if (
                !this.competitionRules[i].groupNum ||
                !Number.isInteger(Number(this.competitionRules[i].groupNum)) ||
                Number(this.competitionRules[i].groupNum) <= 0
              ) {
                return this.$confirm(`请确认${this.cities[i].value}的第一阶段组数是否填写正确！`, '提示', {
                  showCancelButton: false,
                  confirmButtonText: '确定',
                  type: 'warning'
                })
              }

              // 第一阶段小组晋级人数
              if (
                !this.competitionRules[i].groupRiseNum ||
                !Number.isInteger(Number(this.competitionRules[i].groupRiseNum)) ||
                Number(this.competitionRules[i].groupRiseNum) <= 0
              ) {
                return this.$confirm(`请确认${this.cities[i].value}的第一阶段小组晋级人数是否填写正确！`, '提示', {
                  showCancelButton: false,
                  confirmButtonText: '确定',
                  type: 'warning'
                })
              }

              // 第一阶段小组晋级人数 > 每组人数
              if (Number(this.competitionRules[i].groupRiseNum) > (Number(this.competitionRules[i].teamNum) / Number(this.competitionRules[i].groupNum))) {
                return this.$confirm(`第一阶段小组晋级人数不能超过小组人数，请重新设置${this.cities[i].value}的第一阶段小组晋级人数！`, '提示', {
                  showCancelButton: false,
                  confirmButtonText: '确定',
                  type: 'warning'
                })
              }

              // 第二阶段赛制
              if (!this.competitionRules[i].SecondCompetition && this.competitionRules[i].SecondCompetition !== 0) {
                return this.$confirm(`请选择${this.cities[i].value}的第二阶段赛制！`, '提示', {
                  showCancelButton: false,
                  confirmButtonText: '确定',
                  type: 'warning'
                })
              }

              // 同名次小组循环赛
              if (this.competitionRules[i].SecondCompetition === 2) {
                if (this.competitionRules[i].groupNum < 2 || this.competitionRules[i].groupNum > 6) {
                  this.$confirm(`因第二阶段同名次小组循环赛系统支持2-6签的小组对阵，故第一阶段小组循环赛分组数也需满足2-6组，请重新设置${this.cities[i].value}的第一阶段的组数！`, '提示', {
                    showCancelButton: false,
                    confirmButtonText: '确定',
                    type: 'warning'
                  })
                }
              }

              // 交叉淘汰附加赛
              if (this.competitionRules[i].SecondCompetition === 4) {
                // 交叉数
                if (!this.competitionRules[i].crossNum) {
                  return this.$confirm(`请选择${this.cities[i].value}的第二阶段的交叉数！`, '提示', {
                    showCancelButton: false,
                    confirmButtonText: '确定',
                    type: 'warning'
                  })
                }
                const num = Number(this.competitionRules[i].groupRiseNum)
                if (num === 0 || num % 2 !== 0) { // 第一阶段小组晋级人数必须是大于0的偶数
                  return this.$confirm(`第二阶段赛制为交叉淘汰附加赛时，第一阶段小组晋级人数必须为大于0的偶数，请重新设置${this.cities[i].value}的第一阶段小组晋级人数！`, '提示', {
                    showCancelButton: false,
                    confirmButtonText: '确定',
                    type: 'warning'
                  })
                }
              }

              // 淘汰赛
              if (this.competitionRules[i].SecondCompetition === 5) {
                // 第二阶段赛制附加规则
                if (!this.competitionRules[i].allowPlayOff1 && this.competitionRules[i].allowPlayOff1 !== 0) {
                  return this.$confirm(`请选择${this.cities[i].value}的第二阶段赛制附加规则！`, '提示', {
                    showCancelButton: false,
                    confirmButtonText: '确定',
                    type: 'warning'
                  })
                }

                if (
                  this.competitionRules[i].SecondCompetition === 5 &&
                  (Number(this.competitionRules[i].groupNum) * Number(this.competitionRules[i].groupRiseNum) === 2) &&
                  this.competitionRules[i].allowPlayOff1 === 1
                ) {
                  return this.$confirm(`${this.cities[i].value}的第一阶段小组晋级人数导致第二阶段参赛队伍为2支，第二阶段赛制附加规则请选择“无附加赛”！`, '提示', {
                    showCancelButton: false,
                    confirmButtonText: '确定',
                    type: 'warning'
                  })
                }
              }

              // 同名次淘汰附加赛/交叉淘汰附加赛/淘汰赛
              if ([3, 4, 5].includes(this.competitionRules[i].SecondCompetition)) {
                const num = Number(this.competitionRules[i].groupNum)
                if (isNaN(num) || !(num > 0 && (num & (num - 1)) === 0)) { // 组数必须是2的幂次方
                  return this.$confirm(`第二阶段赛制为${this.secondCompetitionRuleList.find(item => item.value === this.competitionRules[i].SecondCompetition).label}时，第一阶段组数必须为2的幂次方，如：2、4、8、16...，请重新设置${this.cities[i].value}的第一阶段组数！`, '提示', {
                    showCancelButton: false,
                    confirmButtonText: '确定',
                    type: 'warning'
                  })
                }
              }
            }
            // 淘汰赛
            if (this.competitionRules[i].FirstCompetition === 5) {
              // 第一阶段赛制附加规则
              if (!this.competitionRules[i].allowPlayOff && this.competitionRules[i].allowPlayOff !== 0) {
                return this.$confirm(`请选择${this.cities[i].value}的第一阶段赛制附加规则！`, '提示', {
                  showCancelButton: false,
                  confirmButtonText: '确定',
                  type: 'warning'
                })
              }
              this.competitionRules[i].playOffPlace = this.competitionRules[i].allowPlayOff === 0 ? 0 : 4
            }
            matchFormatArr.push(this.competitionRules[i])
          }
        }

        if (Number(this.ruleForm.applySize) !== teamNumAll) {
          return this.$confirm('级别队伍数的总和应等于签位数，请重新设置！', '提示', {
            showCancelButton: false,
            confirmButtonText: '确定',
            type: 'warning'
          })
        }

        // 无赛中模式
        if (this.ruleForm.inGameManagementMode == 0) {
          // 无赛中模式没有赛制
          this.ruleForm.competitionMatchFormatList = []
          // 调整出场名单时间
          this.ruleForm.AttendanceList = []
        } else { // 赛中模式
          const arr = []
          matchFormatArr.forEach(item => {
            // 除了小组循环赛，其它类型赛事都没有第二阶段
            if (item.FirstCompetition !== 1) {
              arr.push({
                // id: item.id,
                ctId: item.ctId,
                stage: 1,
                groupCode: Number(item.groupCode),
                groupName: item.groupName,
                groupNickname: item.groupNickname,
                levelNum: Number(item.teamNum),
                matchFormat: item.FirstCompetition,
                groupNum: Number(item.groupNum),
                allowPlayOff: item.allowPlayOff,
                groupRiseNum: Number(item.groupRiseNum),
                playOffPlace: item.playOffPlace
              })
            } else { // 小组循环赛
              arr.push({
                // id: item.id,
                ctId: item.ctId,
                stage: 1,
                groupCode: Number(item.groupCode),
                groupName: item.groupName,
                groupNickname: item.groupNickname,
                levelNum: Number(item.teamNum),
                matchFormat: item.FirstCompetition,
                groupNum: Number(item.groupNum),
                allowPlayOff: item.allowPlayOff,
                groupRiseNum: Number(item.groupRiseNum),
                playOffPlace: item.playOffPlace
              })
              arr.push({
                // id: item.id,
                ctId: item.ctId,
                stage: 2,
                groupCode: Number(item.groupCode),
                groupName: item.groupName,
                groupNickname: item.groupNickname,
                levelNum: Number(item.teamNum),
                matchFormat: item.SecondCompetition,
                crossNum: item.crossNum,
                allowPlayOff: item.allowPlayOff
              })
            }
          })
          this.ruleForm.competitionMatchFormatGroupList = arr
        }

        this.ruleForm.ecertList = this.listImageUrlCert;

        if (this.ruleForm.ctRefundList.length < 1) {
          return this.$message.error('必须设置退费规则！');
        } else if (this.ruleForm.ctEnrollPriceList.some((e) => e.price == 0)) {
          return this.$message.error('费用设置不能为0！');
        } else if (this.ruleForm.ecertList.length < 1) {
          return this.$message.error('请上传电子证书！');
        }
        if (
          !this.ruleForm.matchDescription ||
          this.ruleForm.matchDescription === '<p><br></p>'
        ) {
          return this.$message.error('比赛简介不能为空！');
        }
        this.ruleForm.attachmentsList = this.pdfs;

        if (valid) {
          this.ruleForm.matchSignStartTime = this.ruleForm.applyDate[0];
          this.ruleForm.matchSignEndTime = this.ruleForm.applyDate[1];
          if (this.ruleForm.inGameManagementMode == 1) {
            this.ruleForm.placeInfo = this.ruleForm.__placeInfoTemp__.map(item => item.name).join(',')
          } else {
            this.ruleForm.placeInfo = ''
          }
          this.$confirm(`本场比赛您设置了${this.ruleForm.__placeInfoTemp__.length}块场地，签位数量为${this.ruleForm.applySize}，请核对设置信息！`, '场地信息确认', {
            confirmButtonText: '确认无误',
            cancelButtonText: '取消',
            type: 'warning',
          })
          .then(() => {
            this.$showLoading()
            this.clickFlag = true
            this.$http({
              url: this.$http.adornUrl(
                `/ctCompetition/${!this.ruleForm.id ? 'save' : this.isReviewedEdit ? 'updateApproved' : 'update'}`
              ),
              method: 'post',
              data: this.ruleForm,
            }).then((data) => {
              if (data && data.code === 0) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    this.flagType = 1
                    this.visible = false
                    this.$emit('refreshDataList')
                    this.$showLoading('close')
                  }
                })
              } else {
                this.clickFlag = false
                this.$message.error(data.msg)
                this.$showLoading('close')
              }
            }).catch(() => {
              this.clickFlag = false
            })
          })
          .catch(() => {
            this.$message.info('已取消')
          })
        }
      })
    },
    closeForm () {
      this.showQuill = false
      if (this.flagType === 2) {
        this.$http({
          url: this.$http.adornUrl(`/ctCompetition/delete/` + this.ruleForm.id),
          method: 'get',
        }).then((data) => {
          this.visible = false;
        });
      } else {
        this.visible = false;
      }
    },
    //报名时间改变事件
    applyDateChange (val) {
      this.ruleForm.RegistrationList = [];
      this.ruleForm.AttendanceList = [];
      this.ruleForm.matchStartTime = null;
      this.pickerOptionsCt = null;
      if (this.ruleForm.applyDate == null) {
        this.ruleForm.applyDate = [];
        this.defaultTime = [];
        this.ctDisabled = true;
        this.ruleForm.matchStartTime = null;
        this.matchStartTimePlaceholder = '必须先选择报名时间';
      } else {
        // alert(2)
        this.ctDisabled = false;
        this.ruleForm.matchStartTime = null;
        this.matchStartTimePlaceholder = '请选择比赛时间';
        if (this.ruleForm.applyDate[1]) {
          this.pickerOptionsCt = {
            disabledDate: (time) => {
              return (
                time <
                // new Date(this.ruleForm.applyDate[0])
                this.timechange(this.ruleForm.applyDate[0])
              );
            },
          };
        }
      }
    },
    applyDateChange1 (val) {
      this.ruleForm.AttendanceList = [];
      this.ruleForm.matchStartTime = null;
      if (this.ruleForm.RegistrationList == null) {
        this.ruleForm.RegistrationList = [];
        return;
      }
      if (!this.changeSignUpStartTime()) {
        return;
      }
      if (this.ruleForm.RegistrationList[1]) {
        this.pickerOptionsCt1 = {
          disabledDate: (time) => {
            return (
              time <
              // new Date(this.ruleForm.RegistrationList[1])
              this.timechange(this.ruleForm.RegistrationList[1])
            );
          },
        };
      }
      if (this.ruleForm.RegistrationList.length > 0) {
        this.ruleForm.competitionClub.adjustAppearListStartTime = this.ruleForm.RegistrationList[0];
        this.ruleForm.competitionClub.adjustAppearListEndTime = this.ruleForm.RegistrationList[1];
      } else {
      }
    },
    applyDateChange2 (val) {
      this.ruleForm.matchStartTime = null;

      if (this.ruleForm.AttendanceList == null) {
        this.ruleForm.AttendanceList = [];
        return;
      }
      if (!this.changeShowUpStartTime()) {
        return;
      }
      if (this.ruleForm.AttendanceList[1]) {
        this.pickerOptionsCt2 = {
          disabledDate: (time) => {
            return (
              time <
              //  new Date(this.ruleForm.AttendanceList[1])
              this.timechange(this.ruleForm.AttendanceList[1])
            );
          },
        };
      }

      if (this.ruleForm.AttendanceList.length > 0) {
        this.ruleForm.competitionClub.adjustEnrollListStartTime = this.ruleForm.AttendanceList[0];
        this.ruleForm.competitionClub.adjustEnrollListEndTime = this.ruleForm.AttendanceList[1];
      } else {
      }
    },
    timechange (item) {
      if (item) {
        const dateList = item.split(/[- :]/);
        // let nndate = new Date(dateList[0], dateList[1] - 1, dateList[2], dateList[3], dateList[4], '00')
        let nndate = new Date(
          dateList[0],
          dateList[1] - 1,
          dateList[2],
          '00',
          '00',
          '00'
        );
        return nndate;
      }
    },
    changeMatchStartTime () {
      if (this.ruleForm.matchStartTime && this.ruleForm.AttendanceList[1]) {
        let date1 = new Date(this.ruleForm.AttendanceList[1]).getTime();
        let date2 = new Date(this.ruleForm.matchStartTime).getTime();
        if (date1 > date2 || date1 === date2) {
          this.ruleForm.matchStartTime = null;
          this.$message.error('比赛时间必须>调整出场截止时间');
          this.matchStartTimePlaceholder = '比赛时间必须晚于调整出场截止时间，请重新选择';
        }
      }
      if (this.ruleForm.matchStartTime && this.ruleForm.applyDate[1]) {
        let date1 = new Date(this.ruleForm.applyDate[1]).getTime();
        let date2 = new Date(this.ruleForm.matchStartTime).getTime() - 1000 * 60;
        if (date1 > date2) {
          this.ruleForm.matchStartTime = null;
          this.matchStartTimePlaceholder = '比赛时间必须晚于报名截止时间，请重新选择';
        }
      }
    },
    changeSignUpStartTime () {
      if (this.ruleForm.RegistrationList[0] && this.ruleForm.applyDate[0]) {
        let date1 = new Date(this.ruleForm.applyDate[0]).getTime();
        let date2 = new Date(this.ruleForm.RegistrationList[0]).getTime();
        if (date1 > date2) {
          this.ruleForm.RegistrationList = [];
          this.$message.error('调整报名名单时间应>=比赛报名开始时间');
          return false;
        }
        return true;
      }
    },
    changeShowUpStartTime () {
      if (
        this.ruleForm.AttendanceList[0] &&
        this.ruleForm.RegistrationList[0]
      ) {
        let date1 = new Date(this.ruleForm.RegistrationList[1]).getTime();
        let date2 = new Date(this.ruleForm.AttendanceList[0]).getTime();
        if (date1 > date2) {
          this.ruleForm.AttendanceList = [];
          this.$message.error('调整出场名单开始时间应>=调整报名名单截止时间');
          return false;
        }
        return true;
      }
    },
    //打开图片剪裁框
    openImgdailog (type) {
      this.openImg = true;
      this.$nextTick(() => {
        if (type === 1) {
          this.$refs.upimg.init('ctLevel'); //传入图片类型参数
        }
        if (type === 2) {
          this.$refs.upimg2.init('ctLevel'); //传入图片类型参数
        }
        if (type === 3) {
          if (this.ruleForm.prizeList) {
            this.$refs.upimg3.init('ctLevel'); //传入图片类型参数
          } else {
            this.$message.error('请选择奖项等级');
          }
        }
      });
    },
    //剪裁完成的回显 列表页
    doneup_lb (val, url) {
      this.ruleForm.imgList = val;
      this.listImageUrl = url;
      this.openImg = false;
    },
    //剪裁完成的回显 详情页
    doneup_xq (val, url) {
      this.ruleForm.imgDetailList = val;
      this.detailImageUrl = url;
      this.openImg = false;
    },
    //电子整数 列表页
    doneup_Cert (val, url, path) {
      this.ruleForm.CertimgList = val;
      let arr = {
        imgUrl: path,
        rewardLevel: this.ruleForm.prizeList,
      };
      if (this.verificationBook(path)) {
        this.listImageUrlCert.push(arr);
      }
      this.openImg = false;
    },
    // 验证证书是否已经上传
    verificationBook (path) {
      let arr = 1;

      this.listImageUrlCert.forEach((item, index) => {
        if (item.rewardLevel == this.ruleForm.prizeList) {
          this.listImageUrlCert[index].imgUrl = path;
          arr = 0;
          throw Error();
        }
        arr = 1;
      });
      if (arr === 0) {
        return false;
      } else {
        return true;
      }
    },
    //自定义上传方法
    //没有用el-upload的action方法，如果使用要传递headers属性参数授权
    uploadFileList (param) {
      //列表页图
      this.uploadFile('1', param.file);
    },
    uploadFileDetail (param) {
      //列表页图
      this.uploadFile('2', param.file);
    },
    uploadFile (type, file) {
      let fd = new FormData();
      fd.append('type', 'ctLevel');
      fd.append('file', file);

      this.$http({
        url: this.$http.adornUrl(`/upload/uploadFile`),
        method: 'post',
        data: fd,
      }).then((data) => {
        if (data && data.code === 0) {
          //列表页图
          if (type === '1') {
            this.ruleForm.imgList = data.bean.id;
            this.listImageUrl = URL.createObjectURL(file);
          }
          //详情页图
          if (type === '2') {
            this.ruleForm.imgDetailList = data.bean.id;
            this.detailImageUrl = URL.createObjectURL(file);
          }
          this.$message.success('上传成功!');
        } else {
          this.$message.error('上传失败!');
        }
      });
    },
    // querySearchApplySize(queryString, cb){
    //     let restaurants = this.restaurants;
    //     let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
    //     // 调用 callback 返回建议列表的数据
    //     cb(results);
    // },
    // createFilter(queryString) {
    //     return (restaurant) => {
    //         return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
    //     };
    // },
    // loadAll(){
    //     return [
    //         {"value":"2签位"},
    //         {"value":"4签位"},
    //         {"value":"8签位"},
    //         {"value":"16签位"},
    //         {"value":"128签位"},
    //         {"value":"128签位"}
    //     ]
    // },
    startAgeMenChange (value) {
      this.ageMaxMenMin = value;
    },
    endAgeMenChange (value) {
      this.ageMaxMenMax = value;
    },
    startAgeWomenChange (value) {
      this.ageMaxWomenMin = value;
    },
    endAgeWomenChange (value) {
      this.ageMaxWomenMax = value;
    },
    genderLimitChange (label) {
      //男
      if (label === 0) {
        this.womenDisabled = true;
        this.menDisabled = false;
        this.ruleForm.ageMinWomen = undefined;
        this.ruleForm.ageMaxWomen = undefined;
      }
      //女
      if (label === 1) {
        this.menDisabled = true;
        this.womenDisabled = false;
        this.ruleForm.ageMinMen = undefined;
        this.ruleForm.ageMaxMen = undefined;
      }
      //全部
      if (label === 2) {
        this.menDisabled = false;
        this.womenDisabled = false;
      }
    },
    // table多选事件
    selectionChangeHandle (val) {
      this.delTableList = val;
      if (this.delTableList.length === 0) {
        this.delCtRefundDisabled = true;
      } else {
        this.delCtRefundDisabled = false;
      }
    },
    //退款设置添加事件
    addCtRefund () {
      if (this.ctRefund.minDuration === undefined) {
        this.$message.error('距比赛开始时间不能为空!');
        return;
      }
      if (this.ctRefund.refundScale === undefined) {
        this.$message.error('退款比例不能为空!');
        return;
      }

      let arr = {
        index: this.ruleForm.ctRefundList.length + 1,
        minDuration: this.ctRefund.minDuration,
        refundScale: this.ctRefund.refundScale,
      };
      this.ruleForm.ctRefundList.push(arr);
    },
    //退款设置删除事件
    delCtRefund () {
      for (let i of this.delTableList) {
        this.ruleForm.ctRefundList.splice(i.index - 1, 1);
        for (let j = 0; j < this.ruleForm.ctRefundList.length; j++) {
          this.ruleForm.ctRefundList[j].index = j + 1;
        }
      }
    },
    initCity () {
      this.$http({
        url: this.$http.adornUrl('/sysOrg/list'),
        method: 'get',
      }).then((data) => {
        this.sysOrgList = data && data.code === 0 ? data.list : [];
      });
    },
    selClear () {
      this.placesInfoList = [];
      this.ruleForm.venueAddress = '';
      this.ruleForm.venueId = '';
      this.venueList = [];
      this.ruleForm.cityCode = '';
      this.ruleForm.cityName = '';
      this.cityList = [];
      this.ruleForm.provinceCode = '';
      this.ruleForm.provinceName = '';
      this.provinceList = [];
    },
    changeCity (val) {
      this.selClear();
      if (val === '' || val === null) {
        this.cityDisbaled = true;
        this.provinceDisabled = true;
        this.venueIdDisabled = true;
        return;
      } else {
        this.cityDisbaled = false;
        this.provinceDisabled = false;
        this.venueIdDisabled = false;
      }
      this.getById(val);
    },
    //获取省和市
    getById (val) {
      this.$http({
        url: this.$http.adornUrl(`/dicProvince/queryByOrgId/` + val),
        params: this.$http.adornParams({
          orgId: val,
        }),
        method: 'get',
      }).then((data) => {
        if (data && data.code === 0) {
          // this.cityList.push({
          //     label : data.bean.cityName,
          //     value : data.bean.cityCode
          // })
          // this.ruleForm.cityCode = data.bean.cityCode
          // this.ruleForm.cityName = data.bean.cityName
          // this.provinceList.push({
          //     label : data.bean.proviceName,
          //     value : data.bean.code
          // })
          // this.ruleForm.provinceCode = data.bean.code
          // this.ruleForm.provinceName = data.bean.proviceName
          // this.getByOrgId(val)
          this.provinceList = data.list;
        }
      });
    },
    //获取主办方
    getByOrgId (val) {
      this.$http({
        url: this.$http.adornUrl(`/pbPlaces/getByOrgId/` + val),
        method: 'get',
      }).then((data) => {
        if (data && data.code === 0) {
          this.placesInfoList = data.pbPlacesList;
          for (let i of data.pbPlacesList) {
            this.venueList.push({
              label: i.name,
              value: i.id,
            });
          }
        }
      });
    },
    venueIdChange (val) {
      let obj = {};
      if (val) {
        obj = this.venueList.find((item) => {
          return item.id === val;
        });
        if (obj) {
          this.ruleForm.venueAddress = obj.address;
        }
      }

      // if(val == '' || val === null){
      //     this.ruleForm.venueAddress = ''
      // }else{
      //     this.placesInfoList.forEach(data =>{
      //         if(data.id == val){
      //             this.ruleForm.venueAddress = data.address
      //         }
      //     })
      // }
    },
    addFeeTemplate (type) {
      this.addFeeTemplateVisible = true;
      this.$nextTick(() => {
        this.$refs.addFeeTemplate.init(type);
      });
    },
    chooseTemplate (list, type) {
      this.addFeeTemplateVisible = false;
      if (type === 2) {
        this.ruleForm.ctRefundList = [];
        let index = 1;
        for (let i of list) {
          this.ruleForm.ctRefundList.push({
            index: index++,
            minDuration: i.typeVal,
            refundScale: i.value,
          });
        }
      }
    },
    addPlaceInfoTemp () {
      this.ruleForm.__placeInfoTemp__.push({ name: '' })
    },
    deletePlaceInfoTemp () {
      this.ruleForm.__placeInfoTemp__.pop()
    }
  },
};
</script>

<style scoped>
.el-dialog-custom {
  overflow: hidden !important;
}
.el-dialog-custom /deep/ .el-dialog__body {
  height: 73vh;
  overflow: auto;
}
.el-dialog-custom /deep/ .el-dialog__footer {
  border-top: 1px solid #E9E9E9;
}
</style>

<style>
.imagemore {
  /* display: inline-block; */
  margin-top: 20px;
}
.imagelist {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;

  align-items: center;
}
.infocont {
  display: inline-block;
  margin-right: 30px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 5px;
  overflow: hidden;
}
.deletes .el-icon-delete {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
  color: white;
  font-size: 20px;
}
.chosecolor {
  color: #02b90d !important;
}
.deletes {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
}
.deletes .Mask {
  width: 100%;
  height: 100%;
  background: black;
  opacity: 0.8;
  position: absolute;
  left: 0;
  top: 0;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px dashed #ccc;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.width_ct {
  width: 50%;
}
.sel_width_ct,
.input_width_ct {
  width: 20% !important;
}
.sel_width_ct_small {
  width: 10% !important;
}
.font_later {
  padding-left: 20px;
  font-weight: bold;
  color: #909399;
}
.font_color {
  font-weight: bold;
  color: #909399;
}
.font_style {
  font-weight: bold;
  color: red;
}
.dialog-footer {
  padding-bottom: 150px;
}
.dialog-right {
  float: right;
}

/* 提示框 */
.el-tooltip__popper.is-light {
  border: 1px solid #c0c4cc;
}

.el-tooltip__popper[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: grey !important ;
}

.toolTip > p {
  margin: 0;
  padding-top: 10px;
  height: 14px;
  line-height: 14px;
  font-size: 14px;
  color: #606266;
}
/* 文本框剩余数字提示兼容ie */
.el-input .el-input__count .el-input__count-inner {
  background: none;
  line-height: initial;
  display: inline-block;
  padding: 0 5px;
}
</style>
